import React from "react";
import { Popconfirm, Popover, Button } from "antd";
import { renderIcon, renderTableText } from "../../../lib/utils";
import { FiEdit3 } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const EditIcon = renderIcon(FiEdit3);
const DeleteIcon = renderIcon(RiDeleteBin6Line);

const RecipientsGroupCard = ({
  data,
  handleDelete,
}: any) => {
  const emails = data?.emails || [];
  const jobLinked = data?.jobLinked || [];

  const navigate = useNavigate();

  return (
    <div className="bg-[#F9F9F9] p-3 rounded-lg shadow space-y-2">
      <p className="font-semibold text-base text-primary">
        {renderTableText(data?.groupName)}
      </p>

      {/* EMAILS */}
      <div className="flex items-center gap-2 text-gray-700 text-sm">
        <span className="font-semibold">Emails: </span>
        <span>
          {emails[0]}

          {emails.length > 1 ? "(" + emails.length + ")" : ""}
        </span>

        {/* Eye Button for all emails */}
        {emails.length > 1 && (
          <Popover
            title={`All Emails (${emails.length})`}
            trigger="click"
            content={
              <div className="flex flex-col gap-1 max-h-40 overflow-y-auto">
                {emails.map((email: string, index: number) => (
                  <div
                    key={index}
                    className="border-b pb-1 text-gray-700 text-[14px]"
                  >
                    {email}
                  </div>
                ))}
              </div>
            }
          >
            <Button
              type="text"
              icon={<EyeOutlined />}
              className="text-primary hover:text-blue-600"
            />
          </Popover>
        )}
      </div>

      {/* JOB LINKED */}
      <div className="flex items-center gap-2 text-gray-700 text-sm">
        <span className="font-semibold">Job Linked: </span>

        <span>
          {jobLinked[0]}
          {jobLinked.length > 1 ? ` (${jobLinked.length})` : ""}
        </span>

        {/* Eye Button for all jobs */}
        {jobLinked.length > 1 && (
          <Popover
            title={`All Jobs (${jobLinked.length})`}
            trigger="click"
            content={
              <div className="flex flex-col gap-1 max-h-40 overflow-y-auto">
                {jobLinked.map((job: string, index: number) => (
                  <div
                    key={index}
                    className="border-b pb-1 text-gray-700 text-[14px]"
                  >
                    {job}
                  </div>
                ))}
              </div>
            }
          >
            <Button
              type="text"
              icon={<EyeOutlined />}
              className="text-primary hover:text-blue-600"
            />
          </Popover>
        )}
      </div>

      {/* ACTIONS */}
      <div className="flex justify-end gap-4 mt-3 text-primary">
        <EditIcon
          className="cursor-pointer text-[20px]"
          onClick={() => navigate(`/recipients/edit/${data?._id}`)}
        />

        <Popconfirm
          title="Are you sure to delete this row?"
          onConfirm={() => handleDelete(data?._id)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteIcon className="cursor-pointer text-red-600 text-[20px]" />
        </Popconfirm>
      </div>
    </div>
  );
};

export default RecipientsGroupCard;
